import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { LayoutDashboard } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { PORTAL_URL } from "@/constants/api";
import mixpanel from "@/lib/mixpanel";

interface SidebarPortfolioDashboardSectionProps {
  isMiniMode: boolean;
}

const SidebarPortfolioDashboardSection: React.FC<
  SidebarPortfolioDashboardSectionProps
> = ({ isMiniMode }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleDashboardClick = () => {
    mixpanel.track("Click", { eventDescription: "Dashboard" });
    window.location.assign(`${PORTAL_URL}workspace/admin/portfolio-dashboard`);
  };

  if (isMiniMode) {
    return (
      <TooltipProvider delayDuration={0}>
        <Tooltip open={isHovered}>
          <TooltipTrigger asChild>
            <Button
              variant="ghost"
              size="icon"
              className="w-12 h-12 rounded-full relative group text-muted-foreground hover:text-foreground dark:hover:text-black hover:bg-sky-100"
              onClick={handleDashboardClick}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              <LayoutDashboard
                size={20}
                className="group-hover:text-foreground dark:group-hover:text-black"
              />
            </Button>
          </TooltipTrigger>
          <TooltipContent
            side="right"
            sideOffset={10}
            align="center"
            className="-translate-y-[40%]"
          >
            <p>Dashboard</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    );
  }

  return (
    <Button
      variant="ghost"
      className="h-[44px] w-full rounded-full text-md justify-start hover:bg-sky-100 gap-2 text-muted-foreground hover:text-foreground dark:hover:text-black hover:underline"
      onClick={handleDashboardClick}
    >
      <LayoutDashboard size={20} />
      Dashboard
    </Button>
  );
};

export default SidebarPortfolioDashboardSection;
